import type { BatchData } from '../types';

/** Generates the same CSV as the original Shared HTML's exportCSV(). */
export function exportBatchCsv(b: BatchData): void {
  const total = (b.rows || []).reduce(
    (s, r) => s + (parseFloat(r.amount) || 0),
    0,
  );
  const rows: (string | number | null)[][] = [
    ['Hensley Heritage — Test Batch Export'],
    ['Batch ID', b.metaBatchId],
    ['Product', b.metaProduct],
    ['Date', b.metaDate],
    ['Version', b.metaVersion],
    ['Formulator', b.metaFormulator],
    ['Status', b.batchStatus],
    [],
    ['— Process Parameters —'],
    ['Processing temp (°C)', b.metaTemp],
    ['Cool-down temp (°C)', b.metaCoolTemp],
    ['Mix time (mins)', b.metaMixTime],
    ['Mix speed / method', b.metaMixMethod],
    ['Emulsification method', b.metaEmulsify],
    ['pH target', b.metaPHTarget],
    ['pH measured', b.metaPHMeasured],
    ['pH adjuster', b.metaPHAdjuster],
    ['Viscosity', b.metaViscosity],
    ['Equipment', b.metaEquipment],
    ['Bottle size', b.metaBottleSize],
    ['Batch yield (g)', b.metaBatchYield],
    ['Units', b.metaUnits],
    [],
    ['— Ingredients —'],
    ['#', 'Ingredient', 'INCI Name', 'Supplier', 'Phase', 'Amount (g)', '%', 'Notes'],
    ...(b.rows || []).map((r, i) => {
      const pct =
        total > 0
          ? ((parseFloat(r.amount || '0') / total) * 100).toFixed(2)
          : '';
      return [
        i + 1,
        r.ingredient,
        r.inci,
        r.supplier,
        r.phase,
        r.amount,
        pct,
        r.notes,
      ];
    }),
    [],
    ['— Observations —'],
    ['Appearance', b.metaAppearance],
    ['Scent', b.metaScent],
    ['Skin feel', b.metaSkinFeel],
    ['Process notes', b.batchNotes],
    [],
    ['— Quality & Testing —'],
    ['Preservation efficacy', b.metaPreservation],
    ['Stability test date', b.metaStabilityDate],
    ['Safety / allergen notes', b.metaSafety],
    ['Next steps', b.batchQC],
  ];

  const csv = rows
    .map((row) =>
      row
        .map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`)
        .join(','),
    )
    .join('\r\n');

  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  a.download = `${b.metaBatchId || 'batch'}_ingredients.csv`;
  a.click();
}
